import React, { useCallback, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import { useAuth } from "hooks/useAuth";
import { printBookingPOS } from "../../utils/BookingPOSPrinter";

const normalizePaymentSplits = (booking) => {
  if (!booking?.payment_splits) return booking;
  return {
    ...booking,
    payment_splits: booking.payment_splits.map((split) => {
      const amount = parseInt(split.amount || 0);
      return { ...split, amount: amount >= 10000000 ? amount / 100 : amount };
    }),
  };
};

const PrintBookingDetails = ({ booking, refetch, onSuccess, onError }) => {
  const { user } = useAuth();
  const displayBooking = useMemo(() => normalizePaymentSplits(booking), [booking]);

  const handlePrint = useCallback(() => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this booking?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        Swal.fire("Cancelled", "Printing cancelled", "info");
        return;
      }

      try {
        await printBookingPOS(displayBooking, { type: "invoice", user });
        Swal.fire({ title: "Printing", text: "Booking is being processed...", icon: "success", timer: 1500, showConfirmButton: false });
        onSuccess?.();
        refetch?.();
      } catch (error) {
        console.error("PrintJS Error:", error);
        Swal.fire("Error", "Failed to print booking", "error");
        onError?.();
      }
    });
  }, [displayBooking, onError, onSuccess, refetch, user]);

  useEffect(() => {
    if (displayBooking) handlePrint();
  }, [displayBooking, handlePrint]);

  return <button className="btn btn-sm btn-success" onClick={handlePrint}>Print</button>;
};

export default PrintBookingDetails;
